














































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import InvoiceAgencyDetailReports from '@/components/invoice/agencydetail/Reports.vue';
import InvoiceAgencyDetailDiscrepancies from '@/components/invoice/agencydetail/Discrepancies.vue';
import InvoiceAgencyDetailDocuments from '@/components/invoice/agencydetail/Documents.vue';
import InvoiceAgencyDetailPaymentRecord from '@/components/invoice/agencydetail/PaymentRecord.vue';
import InvoiceAgencyDetailOperationLogs from '@/components/invoice/agencydetail/OperationLogs.vue';
import InvoiceAgencyDetailOperationInitiallyConfirm from '@/components/invoice/agencydetail/OperationInitiallyConfirm.vue';
import InvoiceAgencyDetailOperationSupervisorConfirm from '@/components/invoice/agencydetail/OperationSupervisorConfirm.vue';
import InvoiceAgencyDetailOperationAccountingConfirm from '@/components/invoice/agencydetail/OperationAccountingConfirm.vue';
import InvoiceAgencyDetailOperationConfirmPayment from '@/components/invoice/agencydetail/OperationConfirmPayment.vue';
import InvoiceAgencyDetailOperationAnnotateAccountingSlip from '@/components/invoice/agencydetail/OperationAnnotateAccountingSlip.vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import {
  InvoiceOperationEnum,
  AgencyInvoiceStatusEnum,
  CurrencyEnum,
  ProductTypeEnum,
} from '@/api/types';
import {
  get_agency_invoice_detail,
  getAgencyInvoiceDetail,
  update_agency_invoice,
  updateAgencyInvoice,
} from '@/api/invoice';
import { list_product_summaries, listProductSummaries } from '@/api/product';
import { formatApiError, translateViewResource } from '@/utils/index';
import { productById } from '@/utils/product';
import { translateRouteTitle } from '@/utils/permission';

@Component({
  name: 'InvoiceAgencyDetail',
  components: {
    MaterialCard,
    InvoiceAgencyDetailReports,
    InvoiceAgencyDetailDiscrepancies,
    InvoiceAgencyDetailDocuments,
    InvoiceAgencyDetailPaymentRecord,
    InvoiceAgencyDetailOperationLogs,
    InvoiceAgencyDetailOperationInitiallyConfirm,
    InvoiceAgencyDetailOperationSupervisorConfirm,
    InvoiceAgencyDetailOperationAccountingConfirm,
    InvoiceAgencyDetailOperationConfirmPayment,
    InvoiceAgencyDetailOperationAnnotateAccountingSlip,
  },
})
export default class extends Vue {
  @Prop({ required: true }) private invoiceId!: string;
  private data = {} as get_agency_invoice_detail.Response;
  private loading = true;
  private products: Map<string, list_product_summaries.Product> = new Map();
  private hideOperationPart = false;

  get agencyInvoiceStatus() {
    if (this.data && this.data.status) {
      return this.data.status;
    }
    return AgencyInvoiceStatusEnum.UNKNOWN_INVOICE_STATUS;
  }

  get availableOperations(): InvoiceOperationEnum[] | null {
    if (
      this.data &&
      this.data.availableOperations &&
      this.data.availableOperations.length > 0
    ) {
      return this.data.availableOperations;
    }
    return null;
  }

  get agentName() {
    if (this.data && this.data.agentName) {
      return this.data.agentName;
    }
    return '';
  }

  get showOperationPart() {
    if (
      this.hideOperationPart ||
      !this.availableOperations ||
      this.availableOperations.length === 0
    ) {
      return false;
    }
    if (
      (this.agencyInvoiceStatus as AgencyInvoiceStatusEnum) !==
      AgencyInvoiceStatusEnum.UNKNOWN_INVOICE_STATUS
    ) {
      return true;
    }
    return false;
  }

  get operationPartTitle() {
    if (this.hideOperationPart) {
      return '';
    }
    if (
      (this.agencyInvoiceStatus as AgencyInvoiceStatusEnum) !==
      AgencyInvoiceStatusEnum.UNKNOWN_INVOICE_STATUS
    ) {
      return this.availableOperations && this.availableOperations.length > 0
        ? this.availableOperations.length === 1
          ? this.$t(`InvoiceOperationEnum.${this.availableOperations![0]}`)
          : this.$t(`InvoiceOperationEnum.${this.availableOperations![0]}`) +
            ' & ' +
            this.$t(`InvoiceOperationEnum.${this.availableOperations![1]}`)
        : this.$t('Operation part');
    }
    return '';
  }

  get showOperationInitiallyConfirm() {
    return (
      this.showOperationPart &&
      (this.agencyInvoiceStatus as AgencyInvoiceStatusEnum) ===
        AgencyInvoiceStatusEnum.INVOICE_GENERATED &&
      this.availableOperations &&
      this.availableOperations.some(
        o =>
          (o as InvoiceOperationEnum) ===
          InvoiceOperationEnum.INVOICE_INITIALLY_CONFIRM
      )
    );
  }

  get invoiceAgencyOperationInitiallyConfirmEvent() {
    return InvoiceAgencyDetailOperationInitiallyConfirm.invoiceAgencyOperationInitiallyConfirmEvent;
  }

  get showOperationSupervisorConfirm() {
    return (
      this.showOperationPart &&
      (this.agencyInvoiceStatus as AgencyInvoiceStatusEnum) ===
        AgencyInvoiceStatusEnum.INVOICE_CONFIRMED_INIT &&
      this.availableOperations &&
      this.availableOperations.some(
        o =>
          (o as InvoiceOperationEnum) ===
            InvoiceOperationEnum.INVOICE_SUPERVISOR_CONFIRM ||
          (o as InvoiceOperationEnum) ===
            InvoiceOperationEnum.INVOICE_SUPERVISOR_CONFIRM_REJECT
      )
    );
  }

  get invoiceAgencyOperationSupervisorConfirmEvent() {
    return InvoiceAgencyDetailOperationSupervisorConfirm.invoiceAgencyOperationSupervisorConfirmEvent;
  }

  get showOperationAccountingConfirm() {
    return (
      this.showOperationPart &&
      (this.agencyInvoiceStatus as AgencyInvoiceStatusEnum) ===
        AgencyInvoiceStatusEnum.INVOICE_CONFIRMED_SUP &&
      this.availableOperations &&
      this.availableOperations.some(
        o =>
          (o as InvoiceOperationEnum) ===
            InvoiceOperationEnum.INVOICE_ACCOUNTING_CONFIRM ||
          (o as InvoiceOperationEnum) ===
            InvoiceOperationEnum.INVOICE_ACCOUNTING_CONFIRM_REJECT
      )
    );
  }

  get invoiceAgencyOperationAccountingConfirmEvent() {
    return InvoiceAgencyDetailOperationAccountingConfirm.invoiceAgencyOperationAccountingConfirmEvent;
  }

  get showOperationConfirmPayment() {
    return (
      this.showOperationPart &&
      (this.agencyInvoiceStatus as AgencyInvoiceStatusEnum) ===
        AgencyInvoiceStatusEnum.INVOICE_CONFIRMED &&
      this.availableOperations &&
      this.availableOperations.some(
        o =>
          (o as InvoiceOperationEnum) ===
          InvoiceOperationEnum.INVOICE_CONFIRM_PAYMENT
      )
    );
  }

  get invoiceAgencyOperationConfirmPaymentEvent() {
    return InvoiceAgencyDetailOperationConfirmPayment.invoiceAgencyOperationConfirmPaymentEvent;
  }

  get showOperationAnnotateAccountingSlip() {
    return (
      this.showOperationPart &&
      this.availableOperations &&
      this.availableOperations.some(
        o =>
          (o as InvoiceOperationEnum) ===
            InvoiceOperationEnum.INVOICE_ANNOTATE_ACCOUNTING_SLIP_FINSHED ||
          (o as InvoiceOperationEnum) ===
            InvoiceOperationEnum.INVOICE_ANNOTATE_ACCOUNTING_SLIP_FINSHED_REVOKE
      )
    );
  }

  get invoiceAgencyOperationAnnotateAccountingSlipEvent() {
    return InvoiceAgencyDetailOperationAnnotateAccountingSlip.invoiceAgencyOperationAnnotateAccountingSlipEvent;
  }

  get currency() {
    if (this.data && this.data.currency) {
      return this.data.currency;
    }
    return '';
  }

  get totalPrice() {
    if (this.data && this.data.totalPrice) {
      return this.data.totalPrice;
    }
    return 0;
  }

  get hasDiscrepancy() {
    if (
      this.data &&
      this.data.discrepancies &&
      this.data.discrepancies.length > 0
    ) {
      return true;
    }
    return false;
  }

  mounted() {
    this.fetchData();
  }

  private async fetchData() {
    this.loading = true;
    AppModule.StartProgress();

    await this.fetchAgencyInvoiceDetail();
    await this.fetchProducts();

    AppModule.StopProgress();
    this.loading = false;
  }

  private async fetchProducts() {
    const res = await listProductSummaries({
      types: [
        ProductTypeEnum.E_TICKET,
        ProductTypeEnum.REAL_TICKET,
        ProductTypeEnum.FREE_MATERIAL,
        ProductTypeEnum.BALANCE_CREDIT,
      ],
    });
    this.products = productById(res.products);
  }

  private async fetchAgencyInvoiceDetail() {
    this.data = await getAgencyInvoiceDetail({
      invoiceId: this.invoiceId,
    });
  }

  private async initiallyConfirm(
    $event: Partial<update_agency_invoice.Request>
  ) {
    const req: update_agency_invoice.Request = {
      invoiceId: this.invoiceId,
      operatorName: $event.operatorName || '',
      initiallyConfirm: $event.initiallyConfirm,
      version: this.data.version,
    };
    if ($event.note) {
      req.note = $event.note;
    }

    this.loading = true;
    AppModule.ShowOverlay();
    AppModule.StopProgress();

    try {
      await updateAgencyInvoice(req);
      this.$toast.success(
        `${this.$t('Succeeded {do}', {
          do: this.$t('InvoiceOperationEnum.INVOICE_INITIALLY_CONFIRM'),
        })}`,
        {
          icon: 'mdi-text-box-check',
        }
      );
      UserModule.SetDefaultOperatedBy(req.operatorName);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: this.$t('InvoiceOperationEnum.INVOICE_INITIALLY_CONFIRM'),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    await this.fetchAgencyInvoiceDetail();

    AppModule.StopProgress();
    AppModule.HideOverlay();
    this.loading = false;
  }

  private async supervisorConfirm(
    $event: Partial<update_agency_invoice.Request>
  ) {
    const req: update_agency_invoice.Request = {
      invoiceId: this.invoiceId,
      operatorName: $event.operatorName || '',
      supervisorConfirm: $event.supervisorConfirm,
      version: this.data.version,
    };
    if ($event.note) {
      req.note = $event.note;
    }

    this.loading = true;
    AppModule.ShowOverlay();
    AppModule.StopProgress();

    try {
      await updateAgencyInvoice(req);
      this.$toast.success(
        `${this.$t('Succeeded {do}', {
          do: this.$t(
            req.supervisorConfirm!.reject
              ? 'InvoiceOperationEnum.INVOICE_SUPERVISOR_CONFIRM_REJECT'
              : 'InvoiceOperationEnum.INVOICE_SUPERVISOR_CONFIRM'
          ),
        })}`,
        {
          icon: req.supervisorConfirm!.reject
            ? 'mdi-text-box-remove'
            : 'mdi-text-box-check',
        }
      );
      UserModule.SetDefaultOperatedBy(req.operatorName);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: this.$t(
            req.supervisorConfirm!.reject
              ? 'InvoiceOperationEnum.INVOICE_SUPERVISOR_CONFIRM_REJECT'
              : 'InvoiceOperationEnum.INVOICE_SUPERVISOR_CONFIRM'
          ),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    await this.fetchAgencyInvoiceDetail();

    AppModule.StopProgress();
    AppModule.HideOverlay();
    this.loading = false;
  }

  private async accountingConfirm(
    $event: Partial<update_agency_invoice.Request>
  ) {
    const req: update_agency_invoice.Request = {
      invoiceId: this.invoiceId,
      operatorName: $event.operatorName || '',
      accountingConfirm: $event.accountingConfirm,
      version: this.data.version,
    };
    if ($event.note) {
      req.note = $event.note;
    }

    this.loading = true;
    AppModule.ShowOverlay();
    AppModule.StopProgress();

    try {
      await updateAgencyInvoice(req);
      this.$toast.success(
        `${this.$t('Succeeded {do}', {
          do: this.$t(
            req.accountingConfirm!.reject
              ? 'InvoiceOperationEnum.INVOICE_ACCOUNTING_CONFIRM_REJECT'
              : 'InvoiceOperationEnum.INVOICE_ACCOUNTING_CONFIRM'
          ),
        })}`,
        {
          icon: req.accountingConfirm!.reject
            ? 'mdi-text-box-remove'
            : 'mdi-text-box-check',
        }
      );
      UserModule.SetDefaultOperatedBy(req.operatorName);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: this.$t(
            req.supervisorConfirm!.reject
              ? 'InvoiceOperationEnum.INVOICE_ACCOUNTING_CONFIRM_REJECT'
              : 'InvoiceOperationEnum.INVOICE_ACCOUNTING_CONFIRM'
          ),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    await this.fetchAgencyInvoiceDetail();

    AppModule.StopProgress();
    AppModule.HideOverlay();
    this.loading = false;
  }

  private async confirmPayment($event: Partial<update_agency_invoice.Request>) {
    const req: update_agency_invoice.Request = {
      invoiceId: this.invoiceId,
      operatorName: $event.operatorName || '',
      confirmPayment: $event.confirmPayment,
      version: this.data.version,
    };
    if ($event.note) {
      req.note = $event.note;
    }

    this.loading = true;
    AppModule.ShowOverlay();
    AppModule.StopProgress();

    try {
      await updateAgencyInvoice(req);
      this.$toast.success(
        `${this.$t('Succeeded {do}', {
          do: this.$t('InvoiceOperationEnum.INVOICE_CONFIRM_PAYMENT'),
        })}`,
        {
          icon: 'mdi-text-box-check',
        }
      );
      UserModule.SetDefaultOperatedBy(req.operatorName);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: this.$t('InvoiceOperationEnum.INVOICE_CONFIRM_PAYMENT'),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    await this.fetchAgencyInvoiceDetail();

    AppModule.StopProgress();
    AppModule.HideOverlay();
    this.loading = false;
  }

  private async annotateAccountingSlip(
    $event: Partial<update_agency_invoice.Request>
  ) {
    const req: update_agency_invoice.Request = {
      invoiceId: this.invoiceId,
      operatorName: $event.operatorName || '',
      annotateAccountingSlipFinshed: $event.annotateAccountingSlipFinshed,
      version: this.data.version,
    };
    if ($event.note) {
      req.note = $event.note;
    }

    this.loading = true;
    AppModule.ShowOverlay();
    AppModule.StopProgress();

    const operation = req.annotateAccountingSlipFinshed!.revoke
      ? InvoiceOperationEnum.INVOICE_ANNOTATE_ACCOUNTING_SLIP_FINSHED_REVOKE
      : InvoiceOperationEnum.INVOICE_ANNOTATE_ACCOUNTING_SLIP_FINSHED;
    const successIcon = req.annotateAccountingSlipFinshed!.revoke
      ? 'mdi-file-remove-outline'
      : 'mdi-file-check-outline';
    try {
      await updateAgencyInvoice(req);
      this.$toast.success(
        `${this.$t('Succeeded {do}', {
          do: this.$t(`InvoiceOperationEnum.${operation}`),
        })}`,
        {
          icon: successIcon,
        }
      );
      UserModule.SetDefaultOperatedBy(req.operatorName);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: this.$t(`InvoiceOperationEnum.${operation}`),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    await this.fetchAgencyInvoiceDetail();

    AppModule.StopProgress();
    AppModule.HideOverlay();
    this.loading = false;
  }

  private translateViewResource(
    resource: string,
    options?: { [key: string]: any }
  ) {
    return translateViewResource(
      this.$i18n,
      this.$options.name as string,
      resource,
      options
    );
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
